// frontend/src/services/suggestionService.js
import api from './apiService'; // <-- CORREÇÃO APLICADA AQUI

/**
 * Busca sugestões de descrição e categoria com base em um termo de pesquisa.
 * @param {string} searchTerm - O texto digitado pelo usuário.
 * @returns {Promise<Array>} Uma lista de objetos de sugestão.
 */
export const getDescricaoSuggestions = async (searchTerm) => {
    // Evita buscas desnecessárias por termos muito curtos
    if (!searchTerm || searchTerm.length < 2) {
        return [];
    }
    
    try {
        const response = await api.get(`/financeiro/sugestoes/descricoes/?search=${searchTerm}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar sugestões de descrição:", error.response?.data || error.message);
        // Retorna um array vazio em caso de erro para não quebrar o componente do frontend.
        return [];
    }
};

/**
 * Remove uma sugestão de descrição salva (DescricaoCategoriaPadrao) do usuário.
 * Lançamentos já criados não são afetados.
 * @param {number} id
 */
export const deleteDescricaoSuggestion = async (id) => {
    await api.delete(`/financeiro/sugestoes/descricoes/${id}/`);
};